// extracted by mini-css-extract-plugin
export default {"higlightStars":"Highlight_higlightStars__uLKwo"};